import React from 'react';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import GuideInfoBox from '../components/GuideInfoBox';
import GuideMockButton from '../components/GuideMockButton';
import GuideMockContainer from '../components/GuideMockContainer';
import GuidePageLayout from '../components/GuidePageLayout';
import GuideSection from '../components/GuideSection';
import GuideStepList from '../components/GuideStepList';
import GuideTable from '../components/GuideTable';

const GuideAssessmentDetail: React.FC = () => {
  return (
    <GuidePageLayout
      title="資産の詳細情報を確認する"
      description="資産の登録内容を詳細に確認します。"
      breadcrumbs={[{ label: '資産管理', path: '/guide/assessment/overview' }]}
    >
      <GuideSection title="前提">
        <GuideTable
          headers={['条件', '内容']}
          rows={[
            ['必要な権限', 'ログイン済み（権限不問）'],
            ['ログイン状態', 'ログイン済みであること'],
          ]}
        />
      </GuideSection>

      <GuideSection title="手順">
        <GuideStepList
          steps={[
            { label: '資産管理画面を開く' },
            { label: '検索条件を入力して対象の資産を検索する' },
            { label: '一覧から対象の資産を選択する' },
            {
              label: '「資産詳細」が右パネルに表示される',
              description: '資産の全情報が参照専用で表示されます。',
              content: (
                <GuideMockContainer label="資産詳細（参照モード）">
                  <Stack spacing={1}>
                    <Stack
                      direction="row"
                      alignItems="center"
                      spacing={1}
                      sx={{ pointerEvents: 'none' }}
                    >
                      <IconButton size="small">
                        <ArrowBackIcon fontSize="small" />
                      </IconButton>
                      <Typography variant="h6" fontWeight={700}>
                        資産詳細
                      </Typography>
                    </Stack>
                  </Stack>
                </GuideMockContainer>
              ),
            },
          ]}
        />
      </GuideSection>

      <GuideSection title="表示される情報">
        <GuideTable
          headers={['項目名', '説明']}
          rows={[
            ['資産区分', 'PC / モニター / 周辺機器'],
            ['資産名', '資産の名称'],
            ['利用者', '現在の利用者'],
            ['管理者', '管理責任者'],
            ['管理番号1〜3', '管理用の番号'],
            ['情報1〜3', '補足情報'],
            ['備考', '自由記述の備考'],
            ['作成者/作成日、更新者/更新日', 'メタ情報'],
            ['除却情報', '除却済みの場合、除却理由・除却日・除却詳細を表示'],
          ]}
        />
      </GuideSection>

      <GuideSection title="ボタンと操作">
        <GuideTable
          headers={['操作', '動作']}
          rows={[
            ['← 戻る矢印', '詳細画面を閉じて一覧に戻る'],
            ['編集ボタン', '編集モードに切り替える（除却済みの場合は非表示）'],
            [
              '除却ボタン',
              '資産を除却する（除却済みの場合は非表示）。確認ダイアログで確認後に実行',
            ],
          ]}
        />
        <Stack sx={{ mt: 1 }}>
          <GuideMockContainer label="フッターボタン（除却済みでない場合のみ表示）">
            <Stack direction="row" spacing={2} justifyContent="flex-end">
              <GuideMockButton label="除却" color="error" startIcon={<DeleteForeverIcon />} />
              <GuideMockButton label="編集" startIcon={<EditIcon />} />
            </Stack>
          </GuideMockContainer>
        </Stack>
      </GuideSection>

      <GuideSection title="注意事項">
        <Stack spacing={1}>
          <GuideInfoBox>
            除却済みの資産も詳細を確認できますが、編集ボタンは表示されません。
          </GuideInfoBox>
        </Stack>
      </GuideSection>
    </GuidePageLayout>
  );
};

export default GuideAssessmentDetail;
